import { observer } from "mobx-react-lite";

import { useStores } from "../stores/useStores";
import { ChordSheetScreen } from "./sheet/ChordSheetScreen";
import { ArrangeScreen } from "./edit/ArrangeScreen";
import { EditScreen } from "./edit/EditScreen";
import { SetlistsScreen } from "./setlists/SetlistsScreen";
import { SettingsScreen } from "./settings/SettingsScreen";
import { Shell } from "./Shell";
import { SongsScreen } from "./songs/SongsScreen";

/** Shows the current screen, once the library has loaded. */
export const App = observer(function App() {
    const { library, navigation } = useStores();
    const screen = navigation.screen;

    if (!library.loaded) return null;

    switch (screen.name) {
        case "sheet":
            return <ChordSheetScreen chordSheetId={screen.chordSheetId} />;
        case "arrange":
            return <ArrangeScreen chordSheetId={screen.chordSheetId} />;
        case "edit":
            return <EditScreen chordSheetId={screen.chordSheetId} />;
        case "settings":
            return (
                <Shell>
                    <SettingsScreen page={screen.page} />
                </Shell>
            );
        case "setlists":
            return (
                <Shell>
                    <SetlistsScreen setlistId={screen.setlistId} />
                </Shell>
            );
        default:
            return (
                <Shell>
                    <SongsScreen songId={screen.songId} />
                </Shell>
            );
    }
});
